import useFacility from "../../../../utils/hooks/useFacility";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getShowsList } from "../../../store/show/showActions";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { GET_SHOWS } from "../../../api/apiRoutes";
import { format } from "date-fns";
import { ShowSave } from "../../../models/ShowSave";

export function useSaleMovieManager() {
  const facilityIds = useFacility();
  const dispatch = useDispatch();
  const { get } = useApiRequest();
  const [loading, setLoading] = useState(false);
  const [showsByDate, setShowByDate] = useState<ShowSave[]>([]);

  const getShowsByDate = async (date: Date) => {
    setLoading(true);
    const { result, isError } = await get(GET_SHOWS(facilityIds, format(date, "yyyy-MM-dd")));
    if (!isError) {

      setShowByDate(result);
      setLoading(false);
    }
  };

  useEffect(() => {
    getShowsByDate(new Date());
    dispatch(getShowsList(facilityIds));
  }, []);

  return {
    loading,
    showsByDate,
    getShowsByDate,
  }
}
